// extracted by mini-css-extract-plugin
export default {"heading-container":"b_cd9VF3b6nFMvbYqWiX"};